<template>
  <layout-main-inner title="商品">
    <!-- <el-button
      slot="action"
      type="primary"
      @click="addProduct">新增商品</el-button> -->
    <layout-card-wrap hasHeaderSlot>
      <template slot="title">
        <el-button
          type="primary"
          @click="addProduct">新增组合商品</el-button>
      </template>
      <el-form
        slot="form"
        :inline="true"
        class="margin-botton-0"
        @submit.native.prevent>
        <el-form-item style="margin-bottom: 0">
          <product-group-select
            v-model="config.groupId"
            :showAdd="false"
            :option="{vendorId: userInfo.orgId}" />
        </el-form-item>
        <el-form-item style="margin-bottom: 0">
          <el-radio-group
            v-model="config.status"
            @change="handleChange">
            <el-radio-button :label="null">全部</el-radio-button>
            <el-radio-button :label="1">已上架</el-radio-button>
            <el-radio-button :label="2">未上架</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item style="margin-bottom: 0">
          <el-input
            v-model.trim="config.goodsName"
            placeholder="请输入商品名称"></el-input>
        </el-form-item>
        <el-form-item style="margin-bottom: 0">
          <el-button
            type="primary"
            @click="handleCurrentChange(1)">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table
        border
        :data="list">
        <el-table-column
          fixed="left"
          label="商品名称"
          min-width="200"
          :resizable="false">
          <template slot-scope="{row}">
            <link-route :link-to="`/wxapp-sku-detail?exchangeGoodsId=${row.exchangeGoodsId}&vendorId=${row.vendorId}`">
              {{ row.goodsName }}
            </link-route>
            <el-tag
              v-if="row.storageCount===0"
              type="danger">库存不足</el-tag>
            <el-tag
              v-if="row.isOngoingSeckillGoods === 1"
              type="success">限时特惠</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="商品编号"
          width="90"
          :resizable="false"
          prop="productNumber">
        </el-table-column>
        <el-table-column
          label="排序值"
          width="90"
          :resizable="false"
          prop="sortNumber">
          <template slot-scope="{ row }">
            {{ row.sortNumber }}
            <!-- <i
              slot="reference"
              style="cursor: pointer;"
              class="el-icon-edit"
              @click="updateSort(row)"></i> -->
          </template>
        </el-table-column>
        <el-table-column
          :resizable="false"
          width="70"
          label="商品分组"
          prop="groupName">
        </el-table-column>
        <el-table-column
          :resizable="false"
          label="商品类型"
          width="75">
          <template slot-scope="{ row }">
            {{ row.isVirtualProductBundle === 0 ? '普通单品' : '组合商品' }}
          </template>
        </el-table-column>
        <el-table-column
          :resizable="false"
          label="商品描述"
          min-width="180"
          prop="goodsDesc"></el-table-column>
        <el-table-column
          label="售价"
          width="80"
          :formatter="(row)=> '¥' + row.price"
          prop="price">
        </el-table-column>
        <el-table-column
          width="140"
          :resizable="false">
          <template
            slot="header"
            slot-scope="{column}">
            库存{{ column.index }}
            <el-tooltip
              effect="dark"
              content="设置总库存量必须大于奖品库存"
              placement="top-start">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </template>
          <template slot-scope="{row, $index}">
            <div>
              <span>总库存：{{ row.storageCount + row.remianPrizeCount }}件</span>
              <el-popover
                v-if="row.isVirtualProductBundle === 0"
                :ref="`popover_${$index}`"
                style="margin-left:10px"
                trigger="click"
                placement="right">
                <div style="margin:10px">
                  <el-input-number
                    v-model="row.storageCountBak"
                    controls-position="right"
                    :min="row.remianPrizeCount"></el-input-number>
                  <el-button
                    style="margin-left:10px"
                    type="primary"
                    @click="() => {updateSubmit(row,`popover_${$index}`)}">确定</el-button>
                </div>
                <i
                  slot="reference"
                  style="cursor: pointer;"
                  class="el-icon-edit"></i>
              </el-popover>
            </div>
            <div>奖品：{{ row.remianPrizeCount }}件</div>
          </template>
        </el-table-column>
        <el-table-column
          :resizable="false"
          label="已售数量"
          width="80"
          prop="exchangeCount"></el-table-column>
        <el-table-column
          :resizable="false"
          label="状态"
          width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.status === 1 ? '已上架' : '未上架' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :resizable="false"
          label="最近上架时间"
          width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.upShelfTime | dateformat() }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :resizable="false"
          label="操作"
          fixed="right"
          width="95">
          <template slot-scope="{row}">
            <el-dropdown>
              <el-button type="warning">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <!-- && [1,2,3,4].indexOf(row.source) > -1 -->
                <el-dropdown-item
                  @click.native="updateShelf(row)">{{ row.status===1?"下架":"上架" }}</el-dropdown-item>
                <el-dropdown-item
                  v-if="row.status === 2"
                  @click.native="update(row)">编辑</el-dropdown-item>
                <el-dropdown-item
                  @click.native="editViews(row)">图文设置</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <!-- <el-button
              type="text"
              @click="updateShelf(row)">{{ row.status===1?"下架":"上架" }}</el-button>
            <el-button
              v-if="row.status==2"
              type="text"
              @click="update(row)">编辑</el-button> -->
            <!-- <el-button
              type="text"
              @click="deleteGoods(row)">删除</el-button> -->
            <!-- <a
              v-if="row.status===1"
              style="margin-left: 10px;color: #409EFF; text-decoration: none;"
              :href="row.acode"
              target="_blank">小程序码</a> -->
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <pagination-new
          v-model="config"
          :total="total"
          :fetch="fetchList" />
      </template>
    </layout-card-wrap>

    <product-vac-config-modal ref="vac" />
  </layout-main-inner>
</template>
<script>
import Common from '../../service/common'
import { mapState } from 'vuex'
import ProductGroupSelect from '../../components/wx/product-group-select.vue'
import ProductVacConfigModal from './vacConfig/product-vac-config-modal.vue'
export default {
  name: 'WxappSkuList',
  components: { ProductGroupSelect, ProductVacConfigModal },
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      codeUrl: Common.getwxacode,
      config: { pageNum: 1, pageSize: 10, goodsName: null, status: null, groupId: null }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  activated() {
    this.fetchList()
  },
  mounted() {
    this.config.vendorId = this.userInfo.orgId
    this.fetchList()
  },
  methods: {
    editViews(row) {
      const { exchangeGoodsId, goodsName } = row
      this.$refs.vac.init({ productId: exchangeGoodsId, productName: goodsName })
    },
    updateSubmit(row, _ref) {
      this.loading = true
      this.$store.dispatch(`goods/modifystoragecount`, {
        payload: {
          exchangeGoodsId: row.exchangeGoodsId,
          vendorId: row.vendorId,
          modifyType: 'set',
          count: row.storageCountBak
        },
        success: () => {
          this.loading = false
          // eslint-disable-next-line no-underscore-dangle
          this.$refs[_ref].doClose()
          this.fetchList()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    update(data) {
      this.$router.push(`/wxapp-sku-edit?exchangeGoodsId=${data.exchangeGoodsId}&vendorId=${data.vendorId}`)
    },
    addProduct() {
      this.$router.push('/wxapp-sku-edit?vendorId=' + this.userInfo.orgId)
    },
    deleteGoods(row) {
      this.$confirm('您确定删除该商品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('goods/deletegoods', {
            payload: {
              vendorId: row.vendorId,
              exchangeGoodsId: row.exchangeGoodsId
            },
            success: () => {
              this.loading = false
              this.handleCurrentChange(1)
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    updateShelf(row) {
      this.$confirm('您确定上架/下架该商品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const dispatch = row.status === 1 ? 'downshelfgoods' : 'upshelfgoods'
          this.loading = true
          this.$store.dispatch(`goods/${dispatch}`, {
            payload: {
              vendorId: row.vendorId,
              exchangeGoodsId: row.exchangeGoodsId
            },
            success: () => {
              this.loading = false
              this.handleCurrentChange(1)
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    handleChange() {
      this.fetchList()
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('goods/getgoodslist', {
        payload: this.config,
        success: res => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records.map(i => {
            // i.money = i.goodsPayType === 1 ? i.price + '元' : i.goodsPayType === 2 ? i.points + '积分' : `${i.price}元 / ${i.points}积分`
            i.storageCountBak = i.storageCount
            i.acode = this.codeUrl + `?vendorId=${i.vendorId}&path=pages/we-exchange/detail/index?exchangeGoodsId=${i.exchangeGoodsId}`
            return i
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    updateSort(row) {
      this.$prompt('请输入排序值', '提示', {
        confirmButtonText: '确定', cancelButtonText: '取消', inputPattern: /^\d+$/, inputErrorMessage: '请输入正确的排序值(非负整数)',
        inputValue: row.sortNumber,
        beforeClose: (action, instance, done) => {
          if (action === 'cancel' || action === 'close') {
            done()
          } else {
            this.loading = true
            this.$store.dispatch(`goods/updategoods`, {
              payload: { exchangeGoodsId: row.exchangeGoodsId, sortNumber: instance.inputValue },
              success: () => {
                this.loading = false
                done()
                this.fetchList()
              },
              fail: () => {
                this.loading = false
              }
            })
          }
        }
      })
    }
  }
}
</script>
